import { createApi } from '@reduxjs/toolkit/query/react';

import { apiFormsMergeFields } from '~constants/api';
import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { MergeFieldsResponse } from '~forms/types';

export const mergeFieldsApi = createApi({
  reducerPath: 'formMergeFieldsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiFormsMergeFields }),
  tagTypes: ['mergeFields'],
  endpoints: (builder) => ({
    getMergeFields: builder.query<MergeFieldsResponse, void>({
      query: () => ({ url: '', method: 'GET' }),
      transformResponse: (payload) => unwrap<MergeFieldsResponse>(payload),
      providesTags: ['mergeFields'],
    }),
  }),
});

export const { useGetMergeFieldsQuery } = mergeFieldsApi;
